export default __webpack_public_path__ + "static/media/554.6fb91360.jpg";